// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1HVzh","content":"Consent_content__2_qAb","footer":"Consent_footer__2K-SX"};